module.exports = __webpack_public_path__ + "img/ICN-alt.6a513559.svg";